import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import {
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { FlexModule } from '@angular/flex-layout';
import { BankIdButtonComponent } from '@app/components/bank-id-button/bank-id-button.component';
import { MatIcon } from '@angular/material/icon';
import { BankIdStatusPipe } from '@app/pipes/bankid/bankid-status.pipe';
import { BankIdIndicatorPipe } from '@app/pipes/bankid/bankid-indicator.pipe';
import { ApplicantNameOrIndexByApplicantIdPipe } from '@app/pipes/applicant-name-or-index-by-id.pipe';
import { OptionPipe } from '@app/pipes/option-pipe/option.pipe';
import { NgClass } from '@angular/common';
import { DialogService } from '@app/modules/dialogs/dialog.service';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { ContactInterface } from '@app/interfaces/contact.interface';
import { OfferStepsEnum } from '@app/enums/offer-steps.enum';
import { BankIdStatusList } from '@app/lists/bankid-status-list';
import { BankIdStatusEnum } from '@app/enums/bankid-status.enum';
import { MortgagesService } from '@app/services/mortgages.service';
import { MortgageInterface } from '@app/interfaces/mortgage.interface';

@Component({
    selector: 'app-bankid-page',
    templateUrl: './bankid-page.component.html',
    styleUrls: ['./bankid-page.component.scss'],
    imports: [
        MatAccordion,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        FlexModule,
        MatIcon,
        BankIdButtonComponent,
        BankIdStatusPipe,
        BankIdIndicatorPipe,
        ApplicantNameOrIndexByApplicantIdPipe,
        OptionPipe,
        NgClass,
    ],
})
export class BankIdPageComponent implements OnInit, OnDestroy {
    protected readonly mortgagesService = inject(MortgagesService);
    protected readonly dialogService = inject(DialogService);

    protected destroyed$: Subject<void> = new Subject<void>();

    public mortgage: MortgageInterface = {};
    OfferStepsEnum: typeof OfferStepsEnum = OfferStepsEnum;
    BankIdStatusEnum: typeof BankIdStatusEnum = BankIdStatusEnum;
    BankIdStatusList = BankIdStatusList;

    public isPulsing: boolean;

    ngOnInit() {
        this.mortgagesService.mortgage$
            .pipe(debounceTime(100), takeUntil(this.destroyed$))
            .subscribe((mortgage: MortgageInterface) => {
                if (mortgage) {
                    this.mortgage = mortgage;
                }
            });
    }

    ngOnDestroy(): void {
        this.destroyed$?.next();
        this.destroyed$?.complete();
    }

    public bankIdDialog(applicant: ContactInterface): void {
        this.dialogService.bankId({
            mortgage: this.mortgage,
            applicant,
        });
    }
}
